"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionAddedPaid = void 0;
var _analyticsData = require("@ori/analytics-data");
var _basketItem = require("@ori/basket-item");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../constants");
var _contexts = require("../contexts");
var _hooks = require("../hooks");
var _SectionItem = require("./SectionItem");
var _jsxRuntime = require("react/jsx-runtime");
const SectionAddedPaid = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    addedPaid
  } = (0, _contexts.useBasketContext)();
  const {
    isSimplifiedCheckout
  } = (0, _contexts.useCheckoutBasket)();
  const sectionTestId = getTestId('added-products');
  const baseMapperProps = (0, _react.useMemo)(() => ({
    isBundleItem: false,
    isSubscription: false,
    isOfferItem: false,
    testId: sectionTestId
  }), [sectionTestId]);
  const actionsProps = (0, _react.useMemo)(() => ({
    placement: _analyticsData.Placement.AddedWithCost
  }), []);
  if (addedPaid.length < 1) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_basketItem.BasketSection, {
    title: formatMessage('addedToYourOrderAtACost'),
    overrideMdMaxWidth: isSimplifiedCheckout ? undefined : `${_constants.MAX_WIDTH}px`,
    children: addedPaid.map(item => /*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionItem.SectionItem, {
      item: item,
      mapperProps: baseMapperProps,
      actionsProps: actionsProps
    }, `added-paid-item-${item.itemCode}-${item.itemType}-${item.lineNumber}-${item.totalPrice}`))
  });
};
exports.SectionAddedPaid = SectionAddedPaid;